import React from 'react';
import { motion } from 'framer-motion';
import { Search, MapPin, Users, CheckCircle2, AlertCircle, Music, DollarSign, Calendar } from 'lucide-react';
const artists = [{
  name: 'The Wildwoods',
  location: 'Burlington, VT',
  genres: ['Folk', 'Americana'],
  fee: '$1.5k - $3k',
  draw: '200-400',
  fit: 96,
  avail: 'Available',
  touring: 'Routing through region',
  image: 'https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?auto=format&fit=crop&q=80&w=256&h=256'
}, {
  name: 'Sarah Jarosz',
  location: 'Nashville, TN',
  genres: ['Americana', 'Bluegrass'],
  fee: '$3k - $5k',
  draw: '400-800',
  fit: 91,
  avail: 'Hold',
  touring: 'In market Jun 10-15',
  image: 'https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?auto=format&fit=crop&q=80&w=256&h=256'
}, {
  name: 'Mark Erelli',
  location: 'Boston, MA',
  genres: ['Folk', 'Singer-Songwriter'],
  fee: '$1k - $2k',
  draw: '150-300',
  fit: 88,
  avail: 'Available',
  touring: 'Local',
  image: 'https://images.unsplash.com/photo-1549834125-82d3c48159a3?auto=format&fit=crop&q=80&w=256&h=256'
}, {
  name: 'The Ballroom Thieves',
  location: 'Boston, MA',
  genres: ['Indie Folk', 'Rock'],
  fee: '$2k - $4k',
  draw: '300-600',
  fit: 85,
  avail: 'Conflict',
  touring: 'Playing 50mi away Jun 11',
  image: 'https://images.unsplash.com/photo-1493225457124-a1a2a5fd3d38?auto=format&fit=crop&q=80&w=256&h=256'
}];
export function ArtistSearchPage() {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} className="max-w-7xl mx-auto" data-id="element-1915">
      {/* Filters */}
      <div className="flex flex-wrap items-center gap-3 mb-6" data-id="element-1916">
        <div className="relative flex-1 min-w-[250px]" data-id="element-1917">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-textMuted" data-id="element-1918" />
          <input type="text" placeholder="Search artists by name, genre, or keyword..." className="w-full pl-9 pr-4 py-2 bg-surface border border-border rounded-lg text-sm focus:outline-none focus:border-primary" data-id="element-1919" />
        </div>
        <div className="flex items-center gap-2 bg-surface border border-border rounded-lg px-3 py-2" data-id="element-1920">
          <Calendar className="w-4 h-4 text-textMuted" data-id="element-1921" />
          <span className="text-sm" data-id="element-1922">Jun 12, 2026</span>
        </div>
        <select className="px-3 py-2 bg-surface border border-border rounded-lg text-sm focus:outline-none focus:border-primary text-textMuted" data-id="element-1923">
          <option data-id="element-1924">Any Genre</option>
          <option data-id="element-1925">Folk / Americana</option>
          <option data-id="element-1926">Indie / Alt</option>
        </select>
        <select className="px-3 py-2 bg-surface border border-border rounded-lg text-sm focus:outline-none focus:border-primary text-textMuted" data-id="element-1927">
          <option data-id="element-1928">Fee Range</option>
          <option data-id="element-1929">Under $1,000</option>
          <option data-id="element-1930">$1,000 - $3,000</option>
          <option data-id="element-1931">$3,000+</option>
        </select>
        <button className="px-4 py-2 bg-surface border border-border rounded-lg text-sm font-medium hover:bg-surfaceHover transition-colors" data-id="element-1932">
          Compare Selected
        </button>
      </div>

      {/* Artist Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1933">
        {artists.map((artist, i) => <div key={i} className="bg-surface border border-border rounded-xl p-5 hover:border-primary/50 transition-colors cursor-pointer flex gap-5 group relative" data-id="element-1934">
            <div className="absolute top-3 right-3" data-id="element-1935">
              <input type="checkbox" className="w-4 h-4 rounded border-border text-primary focus:ring-primary bg-background" data-id="element-1936" />
            </div>

            <div className="w-24 h-24 rounded-lg bg-background border border-border overflow-hidden shrink-0" data-id="element-1937">
              <img src={artist.image} alt={artist.name} className="w-full h-full object-cover opacity-80 group-hover:opacity-100 transition-opacity" data-id="element-1938" />
            </div>

            <div className="flex-1 min-w-0" data-id="element-1939">
              <div className="flex items-center gap-3 mb-1" data-id="element-1940">
                <h3 className="text-lg font-semibold truncate group-hover:text-primary transition-colors" data-id="element-1941">
                  {artist.name}
                </h3>
                <span className="px-2 py-0.5 bg-primary/10 text-primary text-xs rounded font-medium shrink-0" data-id="element-1942">
                  {artist.fit}% Fit
                </span>
              </div>

              <div className="text-sm text-textMuted mb-3 flex items-center gap-1.5" data-id="element-1943">
                <MapPin className="w-3.5 h-3.5" data-id="element-1944" /> {artist.location}
              </div>

              <div className="grid grid-cols-2 gap-y-2 gap-x-4 text-sm mb-4" data-id="element-1945">
                <div className="flex items-center gap-1.5" data-id="element-1946">
                  <Music className="w-4 h-4 text-textMuted" data-id="element-1947" />
                  <span className="truncate" data-id="element-1948">{artist.genres.join(', ')}</span>
                </div>
                <div className="flex items-center gap-1.5" data-id="element-1949">
                  <DollarSign className="w-4 h-4 text-textMuted" data-id="element-1950" />
                  <span data-id="element-1951">{artist.fee}</span>
                </div>
                <div className="flex items-center gap-1.5" data-id="element-1952">
                  <Users className="w-4 h-4 text-textMuted" data-id="element-1953" />
                  <span data-id="element-1954">{artist.draw} draw</span>
                </div>
                <div className="flex items-center gap-1.5" data-id="element-1955">
                  <div className={`w-2 h-2 rounded-full ${artist.avail === 'Available' ? 'bg-green-500' : artist.avail === 'Hold' ? 'bg-amber-500' : 'bg-red-500'}`} data-id="element-1956"></div>
                  <span className={artist.avail === 'Available' ? 'text-green-500' : artist.avail === 'Hold' ? 'text-amber-500' : 'text-red-500'} data-id="element-1957">
                    {artist.avail}
                  </span>
                </div>
              </div>

              <div className="pt-3 border-t border-border flex items-center justify-between" data-id="element-1958">
                <span className="text-xs text-textMuted flex items-center gap-1.5" data-id="element-1959">
                  <CheckCircle2 className="w-3.5 h-3.5 text-primary" data-id="element-1960" />{' '}
                  {artist.touring}
                </span>
                <button className="text-xs font-medium text-primary hover:underline" data-id="element-1961">
                  View Profile
                </button>
              </div>
            </div>
          </div>)}
      </div>
    </motion.div>;
}